import { SiteRules } from "../shared/SiteRules";
import { isPageB2C } from "../gtm/GtmUtils";
import { isMemberCenterCallback, isPageJeunesse, isPageMonCompte } from "./DotCaPageChecks";
import { isExcludedOhdioJeunesseVideo, isOhdio } from "./DotCaUtils";
import { SessionStorageKey } from "../shared/SessionStorageKeys";
import { Logger } from "../utils/Logger";

export class DotCaSiteRules extends SiteRules {
  override get isGTMLibraryEnabled(): boolean {
    return !(isPageB2C() || isPageJeunesse() || isPageMonCompte() || isMemberCenterCallback());
  }

  override get isTrackingEnabled(): boolean {
    const jeunesseAudiences = ["prescolaire0-5", "enfants6-8", "preadolescents9-13", "preadolescents9-12"];
    const railMedianetId = dataLayerHelper.get<string>("rail.IdMedianet");
    const mediaIdsCollection = dataLayerHelper.get<string>("media.IdsCollection");
    const isFromRail = railMedianetId && mediaIdsCollection ? mediaIdsCollection.includes(railMedianetId) : false;

    if (isOhdio()) {
      if (isFromRail) {
        // We don't know the target audience of a piece of content played from a rail on Ohdio.
        // Therefore, we don't track any content played from a rail.
        return false;
      }
      if (isExcludedOhdioJeunesseVideo()) {
        // Some specific videos IDs doesn't contain the audience name in the media metadata and need to be filtered
        return false;
      }

      const audienceOhdio = dataLayerHelper.get<string>("page.Audience");
      if (audienceOhdio && jeunesseAudiences.includes(audienceOhdio)) {
        sessionStorage.setItem(SessionStorageKey.DotCaViewedJeunesseContent, "true");
        Logger.verbose("Jeunesse content viewed on Ohdio, not tracking engagement");
        return false;
      }
    }

    const audience = dataLayerHelper.get<string>("media.Audience");
    return !jeunesseAudiences.includes(typeof audience === "string" ? audience : "");
  }
}
